import {
  getAzureBlob,
  getTemporalData,
} from "../../../../services/container.js";
import {
  azureSASTokenToUrl,
  formatAzureBlob,
} from "../../../../components/formatted/FormattedAzureSasToken.js";
import { formattedColorMaterial } from "../../../../components/formatted/FormattedText.js";
import reactImageSize from "react-image-size";

export const fetchTemporalData = async (history, id, t) => {
  const imageDimensions = async function getDimensions(src) {
    return await reactImageSize(src);
  };
  try {
    const responseTemporalData = await getTemporalData(
      { time: history._time },
      id,
    );
    if (responseTemporalData.status === 200) {
      let temporalData =
        responseTemporalData.data.temporalData.length > 0 &&
        responseTemporalData.data.temporalData[0];
      const materialsTemporalData = [];

      const wasteObjects = await getAzureBlob({
        blobUrl: formatAzureBlob(
          temporalData.image_url
            .replace("pictures", "output-surface")
            .replace("-R.jpeg", "-" + id + "-surface.json")
            .replace("-L.jpeg", "-" + id + "-surface.json")
            .replace(".jpeg", "-" + id + "-surface.json"),
        ),
      });

      if (wasteObjects.status === 200) {
        wasteObjects.data.object_segmentations.forEach((annotation) => {
          const annotationToLowerCase = annotation.cls.toLowerCase();
          const index = materialsTemporalData.findIndex(
            (material) => material.name === t(annotationToLowerCase),
          );

          if (index === -1) {
            materialsTemporalData.push({
              name: t(annotationToLowerCase),
              value: annotationToLowerCase,
              color: formattedColorMaterial(annotationToLowerCase),
              count: 1,
              nameAndCount: `${t(annotationToLowerCase)} (1)`,
            });
          } else {
            materialsTemporalData[index].count += 1;
            materialsTemporalData[index].nameAndCount =
              `${t(annotationToLowerCase)} (${materialsTemporalData[index].count})`;
          }
        });
      } else {
        throw new Error("Unexpected response status");
      }
      const dimensions = await imageDimensions(
        azureSASTokenToUrl(temporalData.image_url),
      );
      temporalData.imageDimensions = dimensions;
      const sortedMaterialsTemporalData = materialsTemporalData
        .slice()
        .sort((a, b) =>
          a.value.localeCompare(b.value, "en", { sensitivity: "base" }),
        );
      temporalData.materialsTemporalData = sortedMaterialsTemporalData;
      temporalData.wasteObjectsList = wasteObjects.data.object_segmentations;
      return temporalData;
    } else {
      throw new Error("Unexpected response status");
    }
  } catch (error) {
    console.error("Error fetching temporal data:", error);
    throw error;
  }
};
